import React, { useState, useCallback, useEffect } from "react";
import { useSelector, useDispatch, connect } from "react-redux";
import {
  getPrognosisSubmitted,
  getPrognosisRegistrationConfig,
  getPrognosisRegistration,
  getPrognosisPendingRegister,
  getPrognosisStatistics
} from "src/store/profile/profile.selectors";
import { ModalCancelButton } from "src/routes/RegisterSlaughter/Components";
import styled, { css } from "styled-components";
import { int } from "src/utils/misc.utils";
import { profileActions } from "src/store/profile/profile.actions";
import Modal from "./Modal";
import { motion } from 'framer-motion';
import Button from "./Button";
import { Input } from "./Input";
import { Label } from "./Layout";
import { StyledTable } from "./Table";
import LoadingIndicator from "./LoadingIndicator";

const KindWrapper = styled.div`

&& {
.invisible-cell {
  border: none;
  background: none;
}
  th.amount-kg-header {
    background: #f9f7f3;
    font-weight: 600;
    text-align: right;
    padding-right: 0.7rem;
  }

  tr.dark-bg td,
  tr.dark-bg td:hover {
    background: #f6f6f6;
  }

  td.input-cell {
    padding: 0.6rem;
    input {
      border: 1.5px solid #cdcdcd;
      border-radius: 3px;
      padding: 0.5rem;
      text-align: right;
      width: 80px;
    }
  }

  .statistics {
    margin-bottom: 0.9rem;
    border-bottom: 2px dashed gray;
    padding-bottom: 1.1rem;
    .inner-wrapper {
      background-color: rgb(247, 246, 245);
      padding: 1.5rem;
      padding-top: 0.5;
      margin-top: 2rem;
      margin-bottom: 2rem;
    }

    .statistics-line {
      width: 82%;
      display: flex;
      margin-bottom: 0.7rem;
      .label {
        color: rgb(11, 71, 158);
        font-weight: 600;
      }
      .value {
        margin-left: auto;
        display: flex;

        .kg {
          margin-left: 0.3rem;
        }
      }
    }

    .time-period-header * {
      font-family: "Lato";
    }
    .time-period-header {
      border-top: 1px dashed gray;
      padding-top: 1.2rem;
      margin-top: 2.5rem;
      font-size: 1.1rem;
      &.first {
        margin-top: 0;
      }
      .period-length {
        margin-bottom: 0.8rem;
      }
    }
  }
  .kind-inner-wrapper {
    display: flex;
    flex-direction: column;

    .labelTxt {
      color: rgb(11, 71, 158);
      font-weight: 700;
      margin-right: 1rem;
      width: 5.8rem;
      margin-right: 3rem;
    }

    input.input-amount {
      margin-left: auto;
      width: 7.3rem;
      border: 1px solid rgb(213 213 213);
      border-radius: 3px;
      padding: 0.6rem 0.9rem;
      text-align: right;
    }

    label {
      display: flex;
      width: fit-content;
      margin-bottom: 1.4rem;
      align-items: center;
    }
    .kind-header {
      font-size: 1.8rem;
      margin-top: 0.5rem;
      margin-bottom: 1rem;
      &:not(.first) {
        margin-top: 1.25rem;
      }
    }

    .upcoming-period {
      margin-bottom: 1rem;
      font-size: 1.2rem;
      .label {
        font-weight: 600;
        margin-bottom: 0.3rem;
      }
      .period {
        font-size: 0.9em;
      }
    }
    .show-statistics {
      border: none;
      font-weight: 600;
      font-size: 0.95rem;
      background: rgb(239, 239, 239);

      margin-right: 1rem;
      margin-top: 0.2rem;
      color: #676767;
      padding: 0.7rem;
      border-radius: 5px;
    }

    .period-name {
      font-weight: 600;
      margin-bottom: 0.2rem;
      display: block;
    }
  }

  @media (min-width: 1200px) {
    .kind-inner-wrapper {
      height: 350px;
      .show-statistics {
        margin-top: auto;
        padding: 0.5rem;
      }
    }
  }
}

`;

/*
Alows the user to register how many animals they belive they will send to slaughter, buy and sell the next period
This popup will be shown if the user has registered animal keeping for a certain animal, 
has not yet sent in prognosis for the next periodd for the animal
and it is less than x days to the next period start (configured in config)

Show prgonosis that is submitted already for the next period (if any)
and statistics for prev period, upto now to current period as well for the entire year upto now
*/
export const RegisterPrognosisPopup = ({ }) => {
  // determines when the periods is
  const prognosisRegistrationConfig = useSelector(
    getPrognosisRegistrationConfig
  );
  const prognosisRegistration = useSelector(getPrognosisPendingRegister);
  const [formData, setFormData] = useState({});
  const [statisticsSectionsOpenByAnimalKind, setStatisticsSectionsOpenByAnimalKind] = useState({});
  const [view, setView] = useState("registration"); // "submitted" or "registration"
  const dispatch = useDispatch();

  const hasAnimalKinds = ["pigs", "cattle", "sheep"].filter(
    animalKind => prognosisRegistrationConfig.config[animalKind]?.survey_available
  );

  const getFormattedDate = dateStr => {
    const parts = dateStr.split("-");
    const year = parts[0];
    const month = int(parts[1]);
    const day = parts[2];
    const monthToNorwegianName = {
      1: "jan",
      2: "feb",
      3: "mar",
      4: "april",
      5: "mai",
      6: "jun",
      7: "jul",
      8: "aug",
      9: "sept",
      10: "okt",
      11: "nov",
      12: "des"
    };
    return `${day.replace(/^0/, "")}. ${monthToNorwegianName[month]} ${year}`;
  };

  const cntValueIsValid = val => {
    if ([undefined, ""].includes(val)) {
      return true;
    }
    return !!(val || "").replace(" ", "").match(/^[0-9]+$/);
  };

  // fetch submittted data right away, but statistics data only when user clicks btn to show it
  const prognosisSubmitted = useSelector(getPrognosisSubmitted);
  const prognosisStatistics = useSelector(getPrognosisStatistics);
  useEffect(() => {
    if (
      !prognosisSubmitted.data &&
      !prognosisSubmitted.error &&
      !prognosisSubmitted.isFetching
    ) {
      dispatch(profileActions.fetchPrognosisSubmitted());
    }
  }, [prognosisSubmitted]);

  // when the prev submitted data is fetched, we need to populate the form with this data
  useEffect(() => {
    if (prognosisSubmitted.data) {

      const defaultFormData = {};
      ["pigs", "sheep", "cattle"].forEach(animalKind => {
        ["buy", "sell", "slaughter"].map(enrolmentKind => {
          const data = prognosisSubmitted.data?.[animalKind]?.[enrolmentKind]?.next_period?.data;
          if (data) {
            defaultFormData[animalKind + "_" + enrolmentKind] = data.toString();
          }
        })

      });
      setFormData(defaultFormData);
    }
  }, [prognosisSubmitted]);


  const formIsInvalid = Object.values(formData).find(val => !cntValueIsValid(val));

  var timePeriodConfig = {
    next_period: { "label": "Kommende periode", "id": "next_period", "colspan": "1", "highlight": true },
    prev_period: { "label": "Forrige periode", "id": "prev_period", "colspan": "2" },
    upto_now_period: { "label": "Inneværende periode", "id": "upto_now_period", "colspan": "2" },
    this_year: { "label": "Hittil i år", "id": "this_year", "nodata": true, "colspan": "2" }
  };

  return (
    <Modal noEscape style={{ width: "90vw", maxWidth: "1318px", minHeight: "600px" }} mobileStyle={{ padding: "1.1em", fontSize: "1.1rem" }}>
      <Wrapper loading={prognosisSubmitted.isFetching}>
        <Header className="header">Registrering av prognose</Header>
        {view === "registration" && !prognosisRegistration.done && !prognosisSubmitted.isFetching && (
          <IntroTxt
            dangerouslySetInnerHTML={{
              __html: prognosisRegistrationConfig.config.info_txt_top
            }}
          />
        )}
        {(prognosisRegistration.done && (
          <p style={{ textAlign: "center", fontSize: "1.2rem" }}>
            Prognosen er sendt inn. Bruk "Oppdatering av prognose" på startsiden for å legge til eller endre prognosen.
          </p>
        )) ||
          (prognosisRegistration.error && (
            <p>
              Kunne ikke sende inn prognosen. Vennligst ta kontakt med Furuseth
            </p>
          )) ||
          (prognosisSubmitted.isFetching &&
            <LoadingIndicator withText style={{ top: '110px' }} />
          ) ||
          (prognosisSubmitted.error && (
            <p style={{ fontStyle: "italic" }}>
              Kunne ikke laste inn data for innsending av prognose. Vennligst ta
              kontakt med Furuseth.
            </p>
          )) ||
          (prognosisSubmitted.data && (
            <RegistrationWrapper>
              <StatisticsWrapper>

                {hasAnimalKinds.map((animalKind, animalKindIdx) =>
                  <KindWrapper>
                    <div className="kind-inner-wrapper">
                      <h2 class={`kind-header`}>{{ "pigs": "Slaktegris", "sheep": "Lam", "cattle": "Storfe" }[animalKind]}</h2>
                      <div className="upcoming-period">
                        <div className="label">
                          Kommende periode
                        </div>
                        <div className="period">
                          {getFormattedDate(
                            prognosisRegistrationConfig.config[animalKind].next_period.from
                          )} - {getFormattedDate(
                            prognosisRegistrationConfig.config[animalKind].next_period.to
                          )}
                        </div>

                      </div>
                      {[
                        { "id": "slaughter", "label": "Slakt" },
                        { "id": "buy", "label": "Kjøp" },
                        { "id": "sell", "label": "Salg" },
                      ].filter(enrolmentKind => animalKind !== "sheep" || enrolmentKind.id === "slaughter").map(enrolmentKind =>
                        <>
                          <label>
                            <span className="labelTxt">
                              Antall {enrolmentKind.label}
                            </span>
                            <input className="input-amount"
                              value={formData?.[animalKind + "_" + enrolmentKind.id]}
                              type="number"
                              defaultValue={
                                prognosisSubmitted.data?.[animalKind.id]?.[enrolmentKind.id]?.next_period?.data || ""
                              }
                              onChange={evt => {
                                setFormData(old => ({
                                  ...old,
                                  [animalKind + "_" + enrolmentKind.id]: evt.target.value
                                }));
                              }}

                            />
                          </label>
                        </>
                      )}

                      <button className="show-statistics" onClick={() => {
                        if (!prognosisStatistics.data?.[animalKind]) {
                          dispatch(profileActions.fetchPrognosisStatistics({ animalKind }));
                        }
                        setStatisticsSectionsOpenByAnimalKind(old => ({ ...old, [animalKind]: !old[animalKind] }))
                      }}>
                        {statisticsSectionsOpenByAnimalKind[animalKind] ? "Skjul statistikk" : "Vis statistikk"}
                      </button>

                    </div>
                    <motion.div className="statistics"
                      animate={statisticsSectionsOpenByAnimalKind[animalKind] ? "open" : "collapsed"}
                      initial="collapsed"
                      style={{ boxSizing: "border-box" }}
                      variants={{
                        collapsed: {
                          height: 0, overflow: "hidden", border: "none"
                        },
                        open: {
                          height: "auto",
                          transition: { duration: 0.8 },
                        }
                      }}>



                      <div className="inner-wrapper">

                        {prognosisStatistics.data?.[animalKind] &&
                          <>
                            {["prev_period", "upto_now_period", "this_year"].map((timePeriod, timePeriodIdx) => {

                              let configForTimePeriod = timePeriodConfig[timePeriod];
                              return (<div class="time-period">
                                <h3 class={`time-period-header ${timePeriodIdx === 0 ? "first" : ""}`}>
                                  <span className="period-name">
                                    {timePeriodConfig[timePeriod].label}:
                                  </span>
                                  {!configForTimePeriod.nodata &&
                                    <div className="period-length">
                                      {getFormattedDate(
                                        prognosisRegistrationConfig.config[animalKind][timePeriod].from
                                      )} - {getFormattedDate(
                                        prognosisRegistrationConfig.config[animalKind][timePeriod].to
                                      )}
                                    </div>
                                  }
                                </h3>


                                {["slaughter", "buy", "sell"].filter(kind => (animalKind === "sheep" && kind === "slaughter") || animalKind !== "sheep").map(enrolmentKind =>
                                  <div class="statistics-line">
                                    <div class="label">{{ "slaughter": "Slakt", "buy": "Kjøp", "sell": "Salg" }[enrolmentKind]}</div>
                                    <div class="value">
                                      {prognosisStatistics.data[animalKind][enrolmentKind][timePeriod]?.count} stk
                                      {prognosisStatistics.data[animalKind][enrolmentKind][timePeriod]?.kg &&
                                        <div className="kg">
                                          ({Math.round(prognosisStatistics.data[animalKind][enrolmentKind][timePeriod]?.kg)} kg)
                                        </div>
                                      }
                                    </div>
                                  </div>
                                )}

                              </div>

                              )
                            })}
                          </>
                          || prognosisStatistics.error && <p>Kunne ikke hente statistikk...</p>
                          || <p>Laster...</p>
                        }
                      </div>
                    </motion.div>
                  </KindWrapper>
                )}
              </StatisticsWrapper>
            </RegistrationWrapper>
          ))}
        {formIsInvalid &&
          <p
            style={{
              textAlign: 'center',
              marginTop: '1.3rem',
              marginBottom: '-2rem'
            }}
          >Et eller flere av inputfeltene har ugyldig data.</p>
        }

        {!prognosisSubmitted.isFetching && (
          <ActionBtns>
            <ModalCancelButton
              style={{ marginRight: "0.5rem" }}
              onClick={() =>
                dispatch(profileActions.closePrognosisRegistration())
              }
            >
              Lukk
            </ModalCancelButton>
            {view === "registration" && (
              <Button
                onClick={() => {
                  if (formIsInvalid) {
                    return;
                  }

                  dispatch(
                    profileActions.registerPrognosis({
                      data: formData,
                      onSuccess: () => {
                        setView("submitted");
                      }
                    })
                  );
                }}
                style={{
                  border: "none",
                  ...(formIsInvalid
                    ? {
                      background: "gray",
                      cursor: "not-allowed"
                    }
                    : {})
                }}
                primary
              >
                Send inn prognose
              </Button>
            )}
          </ActionBtns>
        )}
      </Wrapper>
    </Modal >
  );
};

const Wrapper = styled.div`
        ${({ loading }) => !loading && css`
        overflow: auto;
        `}
        padding-bottom: 0.5rem;
        `;



const StatisticsWrapper = styled.div`
        display: flex;
        flex-direction: column;

       

        @media (min-width: 768px) {
          display: grid;
          grid-template-columns: 1fr 1fr;
      }
      @media (min-width: 1200px) {
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
        }

        `;

const AnimalKindHeader = styled.div`
        display: flex;
        margin-top: ${({ first }) => (first ? "0" : "1.5rem")};
        margin-bottom: 0.4rem;
        background: #f2f2f2;
        padding: 0.8rem;
        font-size: 1.1em;


        @media (max-width: 767px) {
          margin - bottom: 0.6rem;
  }
        `;
const AnimalRow = styled.tr`
        margin-bottom: 0rem;
        @media (max-width: 768px) {
          display: flex;
        flex-direction: column;
        margin-bottom: 2rem;
  }
  > td {
          padding - top: 0.25rem;
  }
        `;
const AnimalRows = styled.table``;
const AnimalName = styled.div`
        font-weight: bold;
        padding-right: 1rem;
        `;
const Date = styled.div``;
const Header = styled.div`
        font-weight: 400;
        color: rgb(104, 105, 109);
        font-size: 2.3rem;
        text-align: center;
        margin-bottom: 1.3rem;
        margin-top: 0.9rem;
        `;
const SubHeader = styled.div`
        color: #0b479e;
        font-weight: 700;
        font-size: 1.4rem;
        margin-bottom: 0.6rem;
        `;
const ActionBtns = styled.div`
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 3rem;
        `;
export const RegistrationWrapper = styled.div`
        display: flex;
        flex-direction: column;
        `;
export const IntroTxt = styled.div`
        margin-bottom: 1.5rem;
        line-height: 1.5;
        
        `;

const Table = styled(StyledTable)`
        && {
          th {
          border: 1px solid #ccc;
        border-bottom: 0;
    }
  }
        `;
